import { UtcDate } from '@/helpers/date';
// TODO - used on life & incomeprotection. Difference between this and checkMinAge is in error message
export default {
  computesRequired: true,
  params: ['dateOfInsuranceStart'],
  validate (value, { dateOfInsuranceStart }) {
    const message = `The proposer's age must be between ${this.constants.INSURER_MIN_AGE} and ${this.constants.INSURER_MAX_AGE}.`;

    const valueDate = new UtcDate(value);
    const dateOfInsuranceStartDate = new UtcDate(dateOfInsuranceStart);
    const today = new UtcDate();
    const maxDate = dateOfInsuranceStartDate.isValid() ? dateOfInsuranceStartDate : today.addDays(this.constants.DATE_OF_INSURANCE_START_MAX_DAYS);
    const age = maxDate.differenceInYears(valueDate);

    if (age < this.constants.INSURER_MIN_AGE || age > this.constants.INSURER_MAX_AGE) return message;

    return true;
  },
};
